/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FileFormatTxtIcon20Light = forwardRef('FileFormatTxtIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M6 3a2 2 0 0 0-2 2v2H3V5a3 3 0 0 1 3-3h5.622a1.5 1.5 0 0 1 1.06.44l3.879 3.877c.19.19.324.427.39.683H15.83l-3.854-3.854A.5.5 0 0 0 11.623 3H6Z" }),
        React.createElement("path", { d: "M3 15h1a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2h1a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3Z" }),
        React.createElement("path", { d: "M6.777 8.06H2.233v.96h1.712v4.72h1.12V9.02h1.712v-.96Z" }),
        React.createElement("path", { d: "m12.714 13.74-2.072-3.009 1.856-2.672H11.25L9.986 9.94 8.714 8.06H7.45l1.848 2.664-2.064 3.016h1.24l1.496-2.2 1.488 2.2h1.256Z" }),
        React.createElement("path", { d: "M17.714 8.06H13.17v.96h1.712v4.72h1.12V9.02h1.712v-.96Z" })));
});
